import {
  createSlice,
  createEntityAdapter,
  PayloadAction,
  createSelector,
} from '@reduxjs/toolkit';
import { TeamMember } from './model';
import { RootState } from '../root/root-types';

const SLICE_FEATURE_KEY = 'sentTeamInvites';

export interface TeamInviteState {
  isLoading: boolean;
  teamMembers: TeamMember[];
}

const initialState: TeamInviteState = {
  isLoading: false,
  teamMembers: [],
};

export const sentTeamInvitesSlice = createSlice({
  name: SLICE_FEATURE_KEY,
  initialState: initialState,
  reducers: {
    updateTeamMembers(state, action: PayloadAction<TeamMember[]>) {
      state.teamMembers = action.payload;
    },
  },
});

export const sentTeamInvitesSliceState = (
  rootState: RootState
): TeamInviteState => rootState[SLICE_FEATURE_KEY];

export const getTeamMembers = createSelector(
  sentTeamInvitesSliceState,
  (state) => state?.teamMembers
);
